import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import callsReducer from './components/CallsList/reducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(combineReducers({callsReducer}), composeEnhancers(applyMiddleware()));

